import { FC } from "react";
import FlagPlaceholder from "./team.svg";
import classNames from "classnames";

export type FlagProps = {
  flagId: string | number;
  type?: "teams" | "tournaments";
  className?: string;
  size?: "lg" | "md";
  src?: string;
};

const Flag: FC<FlagProps> = ({
  flagId,
  type = "teams",
  className,
  size = "md",
  src = "",
}) => {
  return (
    <img
      src={
        src ||
        `https://data.askmescore.live/static/images/${type}/${flagId}?size=large`
      }
      alt=""
      className={classNames(
        { "w-4 h-4": size === "md", "w-10 h-10": size === "lg" },
        className,
      )}
      onError={(event) => {
        event.currentTarget.onerror = null;
        event.currentTarget.src = FlagPlaceholder;
      }}
    />
  );
};

export default Flag;
